import { WORD_START_LETTER_REGEX, FIRST_START_LETTER_REGEX } from '@shared/constants/regex';

// Capitalize first letter of every word
export const capitalize = (str: string) => {
  if (typeof str !== 'string') return '';
  return str.replace(WORD_START_LETTER_REGEX, (word) => word.toUpperCase());
};

// Capitalize the first letter of first word only
export const capitalizeFirst = (str: string): string =>
  str.replace(FIRST_START_LETTER_REGEX, (char) => char.toUpperCase());
